module.exports = __webpack_public_path__ + "static/img/user_story_avatar3.5743e4e8.png";